/* ===========================================================
   Hardware Incentive Panel — controller
   Reads data from <script type="application/json" data-hi-data> inside each panel.
   Manages Sho-upgrade toggle, warranty toggle, license stepper.
   On Add-to-Cart click, intercepts the product form and submits a multi-item add to cart.
   =========================================================== */
(function () {

  // Globo defusion: on hardware PDPs that host our incentive panel, Globo's option
  // set (Extended Limited Warranty dropdown) intercepts the ATC click via a CLONED
  // button (.gpo-clone-atc-button) that wraps validation around the real submit.
  // We render warranty natively now, so Globo's option set is redundant AND its
  // clone-button silently swallows ATC clicks when its required field is empty.
  // Strategy: rip out Globo's clone button + option-set + hidden inputs, restore
  // the original ATC button so form submit fires normally. Run repeatedly in case
  // Globo respawns its widget after a delay.
  function defuseGlobo() {
    if (!document.querySelector('[data-hi-panel]')) return;
    document.querySelectorAll('.gpo-clone-atc-button').forEach(function (b) { b.remove(); });
    document.querySelectorAll('.gpo-container').forEach(function (c) { c.remove(); });
    document.querySelectorAll('.gpo-hidden-inputs').forEach(function (c) { c.remove(); });
    document.querySelectorAll('.gpo-original-atc-button').forEach(function (b) {
      b.style.display = '';
      b.style.visibility = 'visible';
      b.removeAttribute('disabled');
      b.classList.remove('gpo-original-atc-button');
    });
  }

  // Sho demo video modal: open on click of [data-hi-sho-video-trigger], close on
  // close button, backdrop click, or Escape. Pause video on close so it doesn't
  // keep playing in the background.
  function initShoVideoModal() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-hi-sho-video-trigger]')) {
        e.preventDefault();
        var modal = document.querySelector('[data-hi-sho-video-modal]');
        if (modal && typeof modal.showModal === 'function') {
          modal.showModal();
          var video = modal.querySelector('video');
          if (video) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        }
        return;
      }
      // Close on X or backdrop click
      var modal = document.querySelector('[data-hi-sho-video-modal][open]');
      if (modal && (e.target.closest('[data-hi-modal-close]') || e.target === modal)) {
        var video = modal.querySelector('video');
        if (video) { video.pause(); video.currentTime = 0; }
        modal.close();
      }
    });
  }

  function init() {
    defuseGlobo();
    // Defuse again after Globo's async render completes (typically <1s)
    setTimeout(defuseGlobo, 250);
    setTimeout(defuseGlobo, 1000);
    initShoVideoModal();
    document.querySelectorAll('[data-hi-panel]').forEach(initPanel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function initPanel(panel) {
    var dataEl = panel.querySelector('[data-hi-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // CDXMT-106: required mode (Zen Stick) has no free plan; a paid plan is
    // always selected and licenses always match the device quantity.
    var required = data.required === true;

    var state = {
      shoYears: required ? 1 : 0, // 0 = free 90 days; 1, 3, or 5 = paid plan years
      warrantyExtended: false,
      licenseCount: 1
    };

    // We avoid caching DOM references for qty/variant inputs because the theme
    // re-renders the quantity-selector and variant-id input on variant change
    // (especially on multi-variant products like Nio). Cached refs go stale and
    // listeners orphan onto removed elements. Always query at runtime instead.
    var productForm = document.querySelector('form[action$="/cart/add"], form[action*="/cart/add"]');

    function getQtyInput() { return document.querySelector('input[name="quantity"]'); }
    function getVariantInput() { return document.querySelector('input[name="id"]'); }

    function getQty() {
      var input = getQtyInput();
      if (!input) return 1;
      var v = parseInt(input.value, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }
    function getCurrentVariantId() {
      var input = getVariantInput();
      return input ? input.value : data.defaultVariantId;
    }

    // --- Sho upgrade toggle ---
    panel.querySelectorAll('[data-hi-plan]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var plan = btn.getAttribute('data-hi-plan');
        panel.querySelectorAll('[data-hi-plan]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        state.shoYears = plan === 'free' ? 0 : parseInt(plan, 10);
        // When a paid plan is freshly selected, default the license count to current qty
        if (state.shoYears > 0) {
          state.licenseCount = Math.max(1, Math.min(getQty(), getQty()));
        } else {
          state.licenseCount = 1;
        }
        renderLicenseStepper();
        renderPlugins();
        renderTotal();
      });
    });

    // --- Warranty toggle ---
    panel.querySelectorAll('[data-hi-warranty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var w = btn.getAttribute('data-hi-warranty');
        panel.querySelectorAll('[data-hi-warranty]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        state.warrantyExtended = (w === 'extended');
        renderTotal();
      });
    });

    // --- License stepper ---
    var stepperInc = panel.querySelector('[data-hi-lic-inc]');
    var stepperDec = panel.querySelector('[data-hi-lic-dec]');
    if (stepperInc) {
      stepperInc.addEventListener('click', function () {
        var max = getQty();
        if (state.licenseCount < max) {
          state.licenseCount++;
          renderLicenseStepper();
        }
      });
    }
    if (stepperDec) {
      stepperDec.addEventListener('click', function () {
        if (state.licenseCount > 1) {
          state.licenseCount--;
          renderLicenseStepper();
        }
      });
    }

    function renderLicenseStepper() {
      if (required) {
        state.licenseCount = getQty();
        var countEl = panel.querySelector('[data-hi-req-count]');
        if (countEl) {
          countEl.textContent = state.licenseCount === 1
            ? 'Includes 1 Sho® license.'
            : 'Includes ' + state.licenseCount + ' Sho® licenses, one per device.';
        }
        renderTotal();
        return;
      }
      var apply = panel.querySelector('[data-hi-license]');
      if (!apply) return;
      var qty = getQty();
      var visible = state.shoYears > 0 && qty >= 2;
      apply.classList.toggle('is-visible', visible);
      if (!visible) return;

      // Clamp license count to current qty
      if (state.licenseCount > qty) state.licenseCount = qty;

      var valEl = panel.querySelector('[data-hi-lic-val]');
      var maxEl = panel.querySelector('[data-hi-lic-max]');
      var planEl = panel.querySelector('[data-hi-lic-plan]');
      var helperEl = panel.querySelector('[data-hi-lic-helper]');
      if (valEl) valEl.textContent = state.licenseCount;
      if (maxEl) maxEl.textContent = qty;
      if (planEl) planEl.textContent = state.shoYears + '-year plan';
      if (helperEl) {
        var remaining = qty - state.licenseCount;
        helperEl.innerHTML = remaining === 0
          ? 'All <strong>' + qty + ' displays</strong> get the ' + state.shoYears + '-year plan.'
          : 'The other <strong>' + remaining + ' display' + (remaining === 1 ? '' : 's') + '</strong> still get <strong>90 days of Sho free.</strong>';
      }
      if (stepperDec) stepperDec.disabled = state.licenseCount <= 1;
      if (stepperInc) stepperInc.disabled = state.licenseCount >= qty;
    }

    // --- Sho plug-ins (collapsible extension of the Sho card) ---
    // Progressive disclosure: the section only shows once a PAID Sho plan is
    // selected, and prices/term auto-match that plan. Plug-ins are added to
    // cart as their own line items, term-matched, in onATCClick below.
    function renderPlugins() {
      var wrap = panel.querySelector('[data-hi-plugins]');
      if (!wrap) return;
      var paid = state.shoYears > 0;
      wrap.classList.toggle('is-visible', paid);
      if (!paid) {
        // No paid plan to attach to — clear selections so we never add an orphan plug-in.
        panel.querySelectorAll('[data-hi-plugin-check]').forEach(function (c) { c.checked = false; });
        return;
      }
      var termEl = panel.querySelector('[data-hi-plugin-term]');
      if (termEl) termEl.textContent = state.shoYears + '-year';
      panel.querySelectorAll('[data-hi-plugin]').forEach(function (row) {
        var key = row.getAttribute('data-hi-plugin');
        var tier = data.plugins && data.plugins[key] && data.plugins[key][state.shoYears];
        var avail = !!(tier && tier.id);
        var priceEl = row.querySelector('[data-hi-plugin-price]');
        if (priceEl) priceEl.textContent = (avail && tier.price) ? (tier.priceFormatted || '$' + formatMoney(tier.price)) : '—';
        var cb = row.querySelector('[data-hi-plugin-check]');
        row.classList.toggle('hi-plugin-row--unavailable', !avail);
        if (cb) { cb.disabled = !avail; if (!avail) cb.checked = false; }
      });
    }

    // Collapse / expand the plug-ins sub-section (open by default; discreet chevron)
    var pluginsToggle = panel.querySelector('[data-hi-plugins-toggle]');
    if (pluginsToggle) {
      pluginsToggle.addEventListener('click', function () {
        var wrap = panel.querySelector('[data-hi-plugins]');
        if (!wrap) return;
        var collapsed = wrap.classList.toggle('is-collapsed');
        pluginsToggle.setAttribute('aria-expanded', String(!collapsed));
      });
    }

    // Plug-in "i" tooltip: don't toggle the checkbox; support click (mobile) + outside-close
    panel.querySelectorAll('[data-hi-tip]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = btn.classList.contains('is-open');
        panel.querySelectorAll('[data-hi-tip]').forEach(function (b) { b.classList.remove('is-open'); });
        if (!open) btn.classList.add('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-hi-tip]')) {
        panel.querySelectorAll('[data-hi-tip]').forEach(function (b) { b.classList.remove('is-open'); });
      }
    });

    // --- Warranty display: read paired variant for the currently selected hardware variant ---
    function updateWarrantyDisplay() {
      var warrantyCard = panel.querySelector('[data-hi-warranty-card]');
      if (!warrantyCard) return;
      var vid = getCurrentVariantId();
      var w = data.warranty && data.warranty[vid];
      if (!w) {
        warrantyCard.style.display = 'none';
        state.warrantyExtended = false;
        // Reset toggle UI to standard
        panel.querySelectorAll('[data-hi-warranty]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-hi-warranty') === 'standard');
        });
        return;
      }
      warrantyCard.style.display = '';

      // Parse total warranty years from the variant title (format:
      // "<product> ...Total of N Years"). Extended adds 2 years on every current
      // SKU (per CDS-EXWTY-*-2Y naming + Jenn 5/19 confirmation), so:
      //   total years = parsed
      //   standard years = total - 2
      var match = (w.title || '').match(/Total of\s+(\d+)\s*Years?/i);
      var totalYears = match ? parseInt(match[1], 10) : null;
      var EXTENSION_YEARS = 2;
      var standardYears = totalYears !== null ? Math.max(0, totalYears - EXTENSION_YEARS) : null;

      function yearSuffix(n) {
        if (n === null || n === undefined) return '';
        return ' (' + n + (n === 1 ? ' Year' : ' Years') + ')';
      }
      var stdTermEl = panel.querySelector('[data-hi-warranty-std-term]');
      if (stdTermEl) stdTermEl.textContent = 'Standard' + yearSuffix(standardYears);
      var extTermEl = panel.querySelector('[data-hi-warranty-ext-term]');
      if (extTermEl) extTermEl.textContent = 'Extended' + yearSuffix(totalYears);
      var priceEl = panel.querySelector('[data-hi-warranty-price]');
      if (priceEl) priceEl.textContent = '+ ' + (w.priceFormatted || '$' + formatMoney(w.price));
    }

    // --- Live total on the ATC button (required mode only, CDXMT-106 QA) ---
    // Shows the real price (device + Sho plan + plug-ins + warranty) so the
    // $99 headline price is never the only number the buyer sees.
    // Money is formatted from a Liquid-rendered sample of 1,234,567.89 so the
    // symbol and separators match the store's format in every market.
    function formatStoreMoney(cents) {
      var sample = data.moneySample || '';
      var m = sample.match(/^([^0-9]*)1(\D?)234\D?567(\D)89(.*)$/);
      var amount = cents / 100;
      if (!m) return '$' + formatMoney(cents);
      var prefix = m[1], thou = m[2], dec = m[3], suffix = m[4];
      var whole = Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      var frac = Math.round((amount - Math.floor(amount)) * 100);
      return prefix + whole + (frac ? dec + (frac < 10 ? '0' : '') + frac : '') + suffix;
    }
    function computeTotal() {
      var qty = getQty();
      var vid = getCurrentVariantId();
      var total = ((data.variantPrices && data.variantPrices[vid]) || 0) * qty;
      var licenses = required ? qty : state.licenseCount;
      if (state.shoYears > 0) {
        var sho = data.sho && data.sho[state.shoYears];
        if (sho && sho.id) total += sho.price * licenses;
        panel.querySelectorAll('[data-hi-plugin]').forEach(function (row) {
          var cb = row.querySelector('[data-hi-plugin-check]');
          if (!cb || !cb.checked) return;
          var tier = data.plugins && data.plugins[row.getAttribute('data-hi-plugin')];
          tier = tier && tier[state.shoYears];
          if (tier && tier.id) total += tier.price * licenses;
        });
      }
      if (state.warrantyExtended) {
        var w = data.warranty && data.warranty[vid];
        if (w && w.id) total += w.price * qty;
      }
      return total;
    }
    function renderTotal() {
      if (!required) return;
      var label = formatStoreMoney(computeTotal());
      document.querySelectorAll('button[name="add"]').forEach(function (b) {
        if (b.classList.contains('sold-out')) return;
        var t = b.querySelector('.single-add-to-cart-button--text');
        if (!t) return;
        if (!t.getAttribute('data-hi-base')) t.setAttribute('data-hi-base', t.textContent.trim());
        t.textContent = t.getAttribute('data-hi-base') + ' · ' + label;
      });
    }
    panel.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-hi-plugin-check]')) renderTotal();
    });

    function formatMoney(cents) {
      var dollars = (cents / 100);
      // No decimals if whole dollar, else 2 decimals
      return dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2);
    }

    // --- Watch for variant + quantity changes ---
    // Document-level delegation so listeners survive when the theme re-renders
    // the quantity-selector or variant-id input (Nio, Way, Vue 2, etc.).
    var lastVariantId = getCurrentVariantId();
    var lastQty = String(getQty());

    function pollState() {
      var vid = getCurrentVariantId();
      if (vid !== lastVariantId) {
        lastVariantId = vid;
        updateWarrantyDisplay();
        renderTotal();
      }
      var q = String(getQty());
      if (q !== lastQty) {
        lastQty = q;
        renderLicenseStepper();
      }
    }

    // Delegated listeners catch events from the current quantity/variant inputs,
    // regardless of whether they've been re-rendered since this script loaded.
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('input[name="quantity"]')) { renderLicenseStepper(); }
      if (e.target.matches('input[name="id"]'))       { updateWarrantyDisplay(); renderTotal(); }
    }, true);
    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) {
        renderLicenseStepper();
      }
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-selector button, .quantity button')) {
        // The custom element mutates input.value programmatically; wait a tick.
        setTimeout(renderLicenseStepper, 50);
      }
    }, true);

    // Safety-net poll — catches custom variant pickers / qty selectors that update
    // values without dispatching events we'd otherwise see.
    setInterval(pollState, 400);

    // --- Intercept Add-to-Cart click (button-level, captures both main + sticky ATC) ---
    // We listen on the button click (capture phase) rather than the form submit, because:
    //   1. The page has TWO product forms (main + sticky ATC) — we'd need to attach to both.
    //   2. preventDefault on the submit button's click halts the form submission entirely,
    //      which also prevents the theme's product-form custom element's submit listener
    //      from running, avoiding a double cart-add.
    function attachATCListeners() {
      document.querySelectorAll('button[name="add"]').forEach(function (btn) {
        if (btn.__hi_attached) return;
        btn.__hi_attached = true;
        btn.addEventListener('click', onATCClick, true);
      });
    }
    attachATCListeners();
    setTimeout(attachATCListeners, 250);
    setTimeout(attachATCListeners, 1000);

    function onATCClick(e) {
      var btn = e.currentTarget;
      // btn.form also resolves the sticky ATC, which sits outside the form and
      // points at it with form="..."; closest('form') alone let it skip the panel.
      var form = btn.form || btn.closest('form');
      if (!form || !(form.action || '').includes('/cart/add')) return;

      // Only intercept if this is a real ATC (not e.g. a buy-it-now dynamic checkout button posting elsewhere)
      e.preventDefault();
      e.stopImmediatePropagation();

      // Use the form from the actually-clicked button for FormData
      productForm = form;

      // The theme's product-form custom element disables the variant input until connectedCallback runs.
      // Defensive: re-enable so FormData picks it up.
      var idInput = productForm.querySelector('[name=id]');
      if (idInput && idInput.disabled) idInput.disabled = false;

      var formData = new FormData(productForm);
      var hardwareId = parseInt(formData.get('id'), 10);
      var hardwareQty = parseInt(formData.get('quantity') || '1', 10);
      if (!hardwareId || isNaN(hardwareQty) || hardwareQty < 1) hardwareQty = 1;
      if (!hardwareId) {
        console.error('[hardware-incentive] No hardware variant ID in form. Aborting.');
        alert('Could not add to cart: no hardware variant selected.');
        return;
      }

      // Required mode: never add the device without its paid Sho plan.
      var shoVariant = data.sho && data.sho[state.shoYears];
      if (required) {
        state.licenseCount = hardwareQty;
        if (!shoVariant || !shoVariant.id) {
          console.error('[hardware-incentive] Sho plan required but no Sho variant found. Aborting.');
          alert('Sorry, we could not add the Sho plan. Please refresh and try again.');
          return;
        }
      }

      // Build base hardware line. Optional-plan hardware carries the 90-day trial
      // property for Klaviyo; required-plan devices get no trial (CDXMT-106).
      var hardwareItem = {
        id: hardwareId,
        quantity: hardwareQty,
        properties: required ? {} : { 'Sho 90-day trial': 'Yes' }
      };
      // Carry through any other line-item properties the form had set
      formData.forEach(function (val, key) {
        if (key.indexOf('properties[') === 0 && key !== 'properties[Sho 90-day trial]') {
          var propKey = key.slice('properties['.length, -1);
          hardwareItem.properties[propKey] = val;
        }
      });

      var items = [hardwareItem];

      // Append Sho paid plan if selected
      if (state.shoYears > 0) {
        if (shoVariant && shoVariant.id) {
          items.push({ id: shoVariant.id, quantity: state.licenseCount });
          // Required mode always covers every device, and the note would go stale
          // if the quantity changes in the cart, so it is left off there.
          if (!required) {
            hardwareItem.properties['Sho paid plan applied to'] = state.licenseCount + ' of ' + hardwareQty + ' displays';
          }
        }
      }

      // Append selected plug-ins (term-matched to the paid Sho plan).
      // Quantity mirrors the paid Sho license count so plug-ins cover the
      // same displays the paid plan applies to.
      if (state.shoYears > 0) {
        panel.querySelectorAll('[data-hi-plugin]').forEach(function (row) {
          var cb = row.querySelector('[data-hi-plugin-check]');
          if (!cb || !cb.checked) return;
          var key = row.getAttribute('data-hi-plugin');
          var tier = data.plugins && data.plugins[key] && data.plugins[key][state.shoYears];
          if (tier && tier.id) {
            items.push({ id: tier.id, quantity: state.licenseCount });
          }
        });
      }

      // Append warranty if extended selected
      if (state.warrantyExtended) {
        var vid = getCurrentVariantId();
        var w = data.warranty && data.warranty[vid];
        if (w && w.id) {
          items.push({ id: w.id, quantity: hardwareQty });
        }
      }

      // Disable ATC button while request is in-flight
      var atcBtn = productForm.querySelector('[type="submit"], [name="add"]');
      var originalText = atcBtn ? atcBtn.textContent : '';
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-busy', 'true');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // `sections` bundles re-rendered section HTML into the same response
        // (Section Rendering API) — the same pattern the theme's product-form uses.
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-bubble' })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (t) {
              throw new Error('Cart add failed [' + r.status + ']: ' + t);
            });
          }
          return r.json();
        })
        .then(function (data) {
          // Phase-2 drawer integration: refresh the cart drawer + header bubble
          // from the bundled section render and slide the drawer open — mirrors
          // renderContents() in product.js. Falls back to the old hard /cart
          // navigate if the drawer isn't on the page or anything goes sideways.
          try {
            var drawer = document.getElementById('Cart-Drawer');
            if (drawer && data && data.sections && data.sections['cart-drawer']) {
              var fresh = new DOMParser()
                .parseFromString(data.sections['cart-drawer'], 'text/html')
                .querySelector('.cart-drawer');
              if (!fresh) throw new Error('no .cart-drawer in section render');
              drawer.innerHTML = fresh.innerHTML;
              if (data.sections['cart-bubble']) {
                var freshCount = new DOMParser()
                  .parseFromString(data.sections['cart-bubble'], 'text/html')
                  .querySelector('.thb-item-count');
                var count = document.querySelector('#cart-drawer-toggle .thb-item-count');
                if (count && freshCount) {
                  count.innerHTML = freshCount.innerHTML;
                }
              }
              if (typeof drawer.removeProductEvent === 'function') {
                drawer.removeProductEvent();
              }
              if (atcBtn) {
                atcBtn.disabled = false;
                atcBtn.removeAttribute('aria-busy');
                if (atcBtn.textContent !== originalText) atcBtn.textContent = originalText;
              }
              drawer.open();
              return;
            }
          } catch (e) {
            console.error('[hardware-incentive] drawer refresh failed, falling back to /cart:', e);
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('[hardware-incentive] cart add failed:', err);
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.removeAttribute('aria-busy');
            if (atcBtn.textContent !== originalText) atcBtn.textContent = originalText;
          }
          // Surface a minimal user-facing fallback so they don't get stuck
          alert("Sorry, something went wrong adding to cart. Please try again or refresh. (Check console for details.)");
        });
    }

    // Initial render
    updateWarrantyDisplay();
    renderLicenseStepper();
    renderPlugins();
    renderTotal();
  }
})();
